module.exports = __webpack_public_path__ + "assets/img/6.91244e06.png";